import { sharingCopyFor } from './sharing-copy.ts';

export function connectionAvailabilityMessage(reason?: string, locale?: string) {
  const copy = sharingCopyFor(locale);
  if (reason === 'pipedream_plan_required') return copy.connectionPlan;
  return copy.connectionUnavailable;
}

export function connectionReadinessMessage(
  readiness?: {
    state: string;
    reason?: string;
    toolCount?: number;
    accountCount?: number;
  },
  locale?: string,
) {
  const copy = sharingCopyFor(locale);
  if (!readiness || readiness.state === 'ready') return null;
  switch (readiness.reason) {
    case 'meta_no_ad_accounts':
      return copy.readyMetaNoAccounts;
    case 'meta_permissions_required':
      return copy.readyPermissions;
    case 'meta_auth_required':
      return copy.readyAuth;
    case 'meta_rate_limited':
      return copy.readyRate;
    case 'mcp_no_tools':
      return copy.readyNoTools;
    case 'mcp_auth_required':
      return copy.readyToolsAuth;
    case 'mcp_tools_unavailable':
      return copy.readyUnavailable;
    case 'meta_unavailable':
      return copy.readyCheck;
    default:
      return readiness.state === 'empty' ? copy.readyEmpty : copy.readyDefault;
  }
}
